var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJobEyeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 9S19.5.75 12 .75 0 9 0 9s4.5 8.25 12 8.25S24 9 24 9zM1.76 9a19.7 19.7 0 0 1 2.49-3.064C6.18 4.002 8.82 2.25 12 2.25c3.18 0 5.819 1.752 7.752 3.686.93.935 1.765 1.962 2.49 3.064-.087.13-.183.274-.293.432a19.78 19.78 0 0 1-2.197 2.633C17.819 13.998 15.179 15.75 12 15.75c-3.18 0-5.819-1.752-7.752-3.685A19.7 19.7 0 0 1 1.758 9h.002z",
    fill: "#A1A1AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5zM6.75 9a5.25 5.25 0 1 1 10.5 0 5.25 5.25 0 0 1-10.5 0z",
    fill: "#A1A1AA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobEyeIcon);
export default __webpack_public_path__ + "static/media/jobEyeIcon.a7c12a0d7ccb94baa2dd891b5f74ab15.svg";
export { ForwardRef as ReactComponent };